export default function LogoContent() {
  return (
    <>
      <div className="max-w-xl mx-auto py-10">
        <div className=" justify-between items-center gap-x-4 lg:flex hidden">
          <div>
            <div className="w-[150px] border bg-[#5BADD2] rounded-full">
              <img src="/images/logo/3 1.png" className="object-cover" alt="" />
            </div>
          </div>
          <div className="w-[300px]">
            <img
              src="/images/logo/logoNovel 1.png"
              className="object-cover"
              alt=""
            />
          </div>
          <div className="w-[170px]">
            <img
              src="/images/logo/Chiang_Mai_University.svg 1.png"
              className="object-cover"
              alt=""
            />
          </div>
        </div>
        <div className="text-center text-2xl text-[#0F4D81] font-medium ">
          <span className="drop-shadow-[0_35px_35px_rgba(255,255,255)]">
            ศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
          </span>
        </div>
      </div>
    </>
  );
}
